import { render, staticRenderFns } from "./Top5Customer.vue?vue&type=template&id=79faa0c6"
import script from "./Top5Customer.vue?vue&type=script&lang=js"
export * from "./Top5Customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79faa0c6')) {
      api.createRecord('79faa0c6', component.options)
    } else {
      api.reload('79faa0c6', component.options)
    }
    module.hot.accept("./Top5Customer.vue?vue&type=template&id=79faa0c6", function () {
      api.rerender('79faa0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/rank/Top5Customer.vue"
export default component.exports